import { useState, useCallback } from 'react';
import { UserPermission } from '../types/admin';
import { fetchUserPermissions, updateUserPermissions } from '../api/admin';

export const useUserPermissions = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchPermissions = useCallback(async (userId: number) => {
    setLoading(true);
    setError(null);
    try {
      const permissions = await fetchUserPermissions(userId);
      return permissions;
    } catch (err) {
      const errorMessage = err instanceof Error ? err.message : 'Ошибка при загрузке разрешений';
      setError(errorMessage);
      return null;
    } finally {
      setLoading(false);
    }
  }, []);

  const updatePermissions = useCallback(async (userId: number, permissions: Partial<UserPermission>) => {
    setLoading(true);
    setError(null);
    try {
      const updatedPermissions = await updateUserPermissions(userId, permissions);
      return updatedPermissions;
    } catch (err) {
      const errorMessage = err instanceof Error ? err.message : 'Ошибка при обновлении разрешений';
      setError(errorMessage);
      return null;
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    loading,
    error,
    fetchPermissions,
    updatePermissions
  };
};